export default {
  product_info: 'Product Info',
  return: 'Return to options',
};
